import { render, staticRenderFns } from "./MyAccreditationEventsMobileCard.vue?vue&type=template&id=cd91d87c&scoped=true&"
import script from "./MyAccreditationEventsMobileCard.vue?vue&type=script&lang=js&"
export * from "./MyAccreditationEventsMobileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd91d87c",
  null
  
)

export default component.exports